// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Specific CSS classes for elements */
.edit-lesson {
  background-color: lightblue;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.edit-lesson h2 {
  color: white;
}

.edit-lesson .form-group {
  margin-bottom: 20px;
}

.edit-lesson label {
  display: block;
  margin-bottom: 5px;
  color: white;
}

/* Apply responsive styles */
@media screen and (max-width: 768px) {
  .edit-lesson {
    padding: 10px;
  }

  .edit-lesson .form-group {
    margin-bottom: 10px;
  }
}

/* White background for input fields and textareas */
.edit-lesson input[type='text'],
.edit-lesson textarea {
  width: 100%;
  padding: 10px;
  background-color: white; /* Add this line to make input fields white */
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/EditLesson.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,oDAAoD;AACpD;;EAEE,WAAW;EACX,aAAa;EACb,uBAAuB,EAAE,6CAA6C;AACxE","sourcesContent":["/* Specific CSS classes for elements */\n.edit-lesson {\n  background-color: lightblue;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.edit-lesson h2 {\n  color: white;\n}\n\n.edit-lesson .form-group {\n  margin-bottom: 20px;\n}\n\n.edit-lesson label {\n  display: block;\n  margin-bottom: 5px;\n  color: white;\n}\n\n/* Apply responsive styles */\n@media screen and (max-width: 768px) {\n  .edit-lesson {\n    padding: 10px;\n  }\n\n  .edit-lesson .form-group {\n    margin-bottom: 10px;\n  }\n}\n\n/* White background for input fields and textareas */\n.edit-lesson input[type='text'],\n.edit-lesson textarea {\n  width: 100%;\n  padding: 10px;\n  background-color: white; /* Add this line to make input fields white */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
